export default __webpack_public_path__ + "static/media/icon_avatar_placeholder.24f7813e.svg";